import config from "./config";

function CanvasBackground(img, bgWidth, speed = 1, x = 0, y = 0) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = bgWidth;
    canvas.height = img.height;
    this.image = canvas;
    this.dx = x;
    this.dy = y;
    this.x = 0;

    this.update = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.x -= speed * config.speed;

        for (let posX = this.x; posX < bgWidth; posX += img.width) {
            ctx.drawImage(img, posX, 0);
        }
    };
}

export default CanvasBackground;